import onReady from '../utils/onReady';
import $ from 'jquery';

/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class ShowOnScroll {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor() {
        // Run initializing code once the DOM is ready.
        const container = $('[data-show-on-scroll]');
        onReady(() => this.init(container));
    }


    throttle(fn, threshold, scope) {
        threshold = threshold || (threshold = 250);
        let last,
            deferTimer;

        return () => {
            let context = scope || this,
                now = +new Date(),
                args = arguments;

            if (last && now < last + threshold) {
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, threshold);
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    }

    doShowOnScroll(unshownAmount) {

        $( window ).scroll(this.throttle(function () {

            if (unshownAmount) {
                // Only loop through unshown items
                let totalItems = this.dom.unshownItems.length,
                    startAt = totalItems - unshownAmount; // So we avoid checking the placement of once hidden elements, that are now visible

                for (let i = startAt; i < totalItems; i++) {
                    let needsShowing = this.isElementInViewport(this.dom.unshownItems[i]);

                    // If the first element should be shown, show it and continue loop
                    if (needsShowing) {
                        let item = $(this.dom.unshownItems[i]),
                            delayIndex = i - startAt,
                            delay = (delayIndex * 50) + 'ms';

                        // Delay transitions if there are multiple element to show
                        if (delayIndex) {
                            item.css({
                                '-webkit-transition-delay': delay,
                                'transition-delay': delay
                            });
                        }

                        // Show item
                        item.addClass('showing');

                        // This is needed to calculate where in the array the loop should start next time
                        // as we don't want to check the placement of once hidden elements, which are now showing
                        unshownAmount--;
                    }
                    else {
                        // If the first element should NOT be shown, stop the loop,
                        // because the first element is always shown before the next
                        break;
                    }
                }
            }
        }, 100));


        // Trigger scroll event at page load to show hidden elements already in the viewport
        $( window ).scroll();
    }

    isElementInViewport(el) {
        let rect = el.getBoundingClientRect();
        return (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) - 80
        );
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            unshownItems: $('[data-show-on-scroll]'),
        };

        // Get and store the DOM-reference to the container we've been given.
        const unshownAmount = this.dom.unshownItems.length;
        this.doShowOnScroll(unshownAmount);

    }

}


export default ShowOnScroll;